import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { TextInput, Button, Loading, Utils } from "../../Components/Components";

import "./ResetPassword.scss";

export const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [password, setPassword] = useState("");

  const form = useRef();

  const { hash } = useParams();

  const validatePassword = (password, confirmPassword) => {
    const lengthCheck = password.length >= 6 && password.length <= 30;
    const numberCheck = /\d/.test(password);
    const lowerCaseCheck = /[a-z]/.test(password);
    const upperCaseCheck = /[A-Z]/.test(password);
    const specialCharCheck = /[$*&@#]/.test(password);
    const someInputNotFill = !password || !confirmPassword;
    const passwordsNotMatch = password !== confirmPassword;
    const validChars = /^[a-zA-Z0-9$*&@#]*$/.test(password)

    if (someInputNotFill) return "Please fill out both fields.";
    if (passwordsNotMatch) return "The passwords do not match. Please try again.";
    if (!lengthCheck) return "Password must be between 6 and 30 characters.";
    if (!numberCheck) return "Password must contain at least one number.";
    if (!lowerCaseCheck) return "Password must contain at least one lowercase letter.";
    if (!upperCaseCheck) return "Password must contain at least one uppercase letter.";
    if (!specialCharCheck) return "Password must contain at least one special character ($*&@#).";
    if(!validChars) return "Password must contain only letters, numbers and the characters $*&@#"

    return "";
  };

  const handleSaveNewPassword = async () => {
    const passwordError = validatePassword(password, confirmPassword);
    if (passwordError) {
      return Utils.Alert({ title: "Error", text: passwordError });
    }

    setLoading(true);
    const res = await Utils.recoverPassword({ new_password: password, token: hash });

    if (res.status === 400) {
      Utils.Alert({ title: "Error", text: res.data.error });
    } else {
      Utils.Alert({
        title: "Success",
        text: res.data.details,
        closeOnConfirm: true,
        callback: () => {
          window.location.href = "/portal";
        },
      });
    }

    return setLoading(false);
  };

  return (
    <div className='content loginPage'>
      <Loading visible={loading} />
      <div className='card'>
        <img className='wave-yellow' src='/images/waves.png' alt='' />
        <div className='welcome'>
          <img src='/images/logos/Logo-flag.png' alt='' />
          <p className='text-shadow'>
            Over four decades of history, Friboi has become the largest Beef packer and major Beef exporter in
            Brazil. Recognized as a leading global brand, with presence in over 70 countries we have the
            unique responsibility to take care of our beef which can be translated into quality,
            sustainability, food safety, health, nutrition and well being of millions of families in the
            world. This makes us very proud of doing our best every day to be a trustworthy beef brand. In
            order to feed the world with the best beef there is to offer we count on the most qualified team
            followed by the best facilities in Brazil.
          </p>
          <div className='logos'>
            <div className='logoContainer'>
              <img className='logo-1953' src='/images/logos/1953@2x.png' alt='' />
            </div>
            <div className='logoContainer'>
              <img className='logo-black' src='/images/logos/Black-02.png' alt='' />
            </div>
            <div className='logoContainer'>
              <img className='logo-farms' src='/images/logos/Farms@2x.png' alt='' />
            </div>
            <div className='logoContainer'>
              <img className='logo-grain' src='/images/logos/Grain Valley@2x.png' alt='' />
            </div>
            <div className='logoContainer'>
              <img src='/images/logos/Steakhouse@2x.png' alt='' />
            </div>
          </div>
        </div>
        <div className='login'>
          <div className='logo'>
            <div className='logo-image'>
              <img src='/images/logos/FRIBOI_White.png' alt='' />
            </div>
            <label htmlFor=''>
              Client
              <br />
              Portal
            </label>
          </div>
          <form name='loginForm' className='form' ref={form}>
            <div className='username field'>
              <TextInput value={password} type='password' caption='Password' onChange={setPassword} />
            </div>
            <div className='password field'>
              <TextInput
                value={confirmPassword}
                type='password'
                caption='Confirm password'
                onChange={setConfirmPassword}
              />
            </div>
            <div className='loginButton'>
              <Button type='red' caption='Save' onClick={handleSaveNewPassword} />
            </div>

            <div className='forgotpassword'>
              <Link to='/portal'>Back to login?</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
